"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.instance = (constructor) => {
    ;
    ({} instanceof constructor);
    return (value) => value instanceof constructor;
};
//# sourceMappingURL=instance.js.map